export const ourTeamData = [
  {
    name: "Hani Ebrahim",
    designation: "CEO/Managing Director",
    image: "seed/image/HANI.png",
  },
  {
    name: "Ihab K A Bashir",
    designation: "Asst.General Manager",
    image: "seed/image/IHAB.png",
  },
  {
    name: "Mohammed Eissa",
    designation: "Operation Manager",
    image: "seed/image/EISSA.png",
  },
  {
    name: "Hussain Sarmad",
    designation: "Finance Manager",
    image: "seed/image/HUSSAIN.png",
  },
 
  {
    name: "Abba Oumar",
    designation: "Manager of Sales, Marketing, and Customer Relations",
    image: "seed/image/ABBA.png",
  },
  {
    name: "Abdulaziz Fateh Muhammad",
    designation: "IT Manager",
    image: "seed/image/AZIZ.png",
  },
  {
    name: "Sameer Ali",
    designation: "Head Of DET, DUBAI COURT, TASHEEL",
    image: "seed/image/SAMEER.png",
  },
  {
    name: "Aseel Abdo",
    designation: "Head Of DHA Department",
    image: "seed/image/ASEEL.png",
  },
  {
    name: "Azza Alaa",
    designation: "Amer Karama Branch Supervisor",
    image: "seed/image/AZZA.png",
  },
  {
    name: "Adeel Zia",
    designation: "Head Of Typing Department",
    image: "seed/image/ADEEL.png",
  },
  {
    name: "Saeed Anwar",
    designation: "Head Of Hr Department",
    image: "seed/image/SAEED.png",
  },
];
